import { useState } from 'react';
import { useResponsiveValueState } from '@saviynt/common';

import {
  SCREEN_SIZE_DESKTOP_SMALL,
  SCREEN_SIZE_MOBILE_XLARGE,
  SCREEN_SIZE_TABLET_XSMALL,
  SCREEN_WIDTH_QUERIES,
} from '../../../shared/constants';

const useResponsiveLayout = () => {
  const [mediaQueryValue, setMediaQueryValue] = useState(0);

  useResponsiveValueState(setMediaQueryValue, SCREEN_WIDTH_QUERIES);

  const mobileXlargeQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === SCREEN_SIZE_MOBILE_XLARGE
  );
  const tabletXSmallQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === SCREEN_SIZE_TABLET_XSMALL
  );
  const desktopSmallQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === SCREEN_SIZE_DESKTOP_SMALL
  );

  const isMobileXlargeWidth =
    (mobileXlargeQuery?.value ?? 0) <= mediaQueryValue;
  const isTabletXSmallWidth =
    (tabletXSmallQuery?.value ?? 0) <= mediaQueryValue;
  const isDesktopSmallWidth =
    (desktopSmallQuery?.value ?? 0) <= mediaQueryValue;

  return { isMobileXlargeWidth, isTabletXSmallWidth, isDesktopSmallWidth };
};

export default useResponsiveLayout;
